
'use client';
import { toast } from 'sonner';
import { AppDispatch, RootState } from '@/redux/store';
import { useRouter } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';
import { APP_ROUTES } from '@/lib/routing/appRoutes';
import useUserProps from '../user/useUserProps';
import { useCallback } from 'react';
import api from '@/lib/axios';

const errorsToSkip = [
   "Virtual Account not available",
   "Minimum amount for"
]


const useToolkit = () => {
   const router = useRouter();
   const useAppDispatch = useDispatch.withTypes<AppDispatch>()
   const useAppSelector = useSelector.withTypes<RootState>()
   const dispatch = useAppDispatch();
   const { userInfo } = useAppSelector((state) => state?.user)
   const { userId: userid } = useAppSelector((state) => state?.basicInfo)
   const userId = userInfo?.userId || userid

   const { endUserSession } = useUserProps()
   const { user } = useAppSelector((state) => state.user)

   const toastSuccess = (message: string) => toast.success(message);
   const toastInfo = (message: string) => toast.info(message);
   const toastError = (message: string) => toast.error(message);

   const isLocalEnv = process.env.NODE_ENV === 'development'

   const isPersonalAccount = user?.endUser
      ? user?.endUser[0]?.userType === 1
      : user?.enduser[0]?.userType === 1;

   const isBusinessAccount = user?.endUser
      ? user?.endUser[0]?.userType === 2
      : user?.enduser[0]?.userType === 2;

   const handleRequestError = (error: any) => {
      const errorMessage = error?.response?.data?.message;
      const errorArray = error?.response?.data?.errors;
      const shouldSkip = errorsToSkip.some(skip => errorMessage?.toLowerCase().includes(skip.toLowerCase()));

      if (errorMessage?.toLowerCase()?.includes('unauthenticated.')) {
         // endUserSession();
         //  router.push(APP_ROUTES.GENERAL.HOMEPAGE)
      } else if (Array.isArray(errorArray) && errorArray?.length > 0) {
         errorArray?.map((item) => toastError(item));
      } else if (errorMessage?.length && !shouldSkip) {
         toastError(errorMessage || 'Something went wrong');
      } else {
         // toastError('Something went wrong, please retry');
      }
   };

   const showValue = (val: any) => val || 'N/A';

   const verifyUserKyc = useCallback(async () => {
      try {
         const { data: { content: { data }, }, } = await api.post("get-user-kyc")

         return data
      } catch (error) {
         //   console.error("KYC verification error:", error)
         return error;
      }
   }, [userId])


   return {
      user,
      handleRequestError,
      toastSuccess,
      toastInfo,
      toastError,
      dispatch,
      useAppSelector,
      showValue,
      isLocalEnv,
      isPersonalAccount,
      isBusinessAccount,
      verifyUserKyc
   }
}

export default useToolkit